const ADMIN_EMAILS = [
  'johnlemusic@gmail.com',
];

export const isAdmin = (email: string | undefined): boolean => {
  if (!email) return false;
  return ADMIN_EMAILS.includes(email.toLowerCase());
};

export const isAdminByRole = (role: string | undefined): boolean => {
  return role === 'admin';
};
